import ModalPanel from '@admin/components/modal_panel'
import Message from '@admin/components/message'
import Button from '@admin/components/button'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class Copyright extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Message { ...this._getMessage() } />
      </ModalPanel>
    )
  }

  _getMessage() {
    return {
      svg: 'copyright',
      title: 't(Licensing Warning)',
      component: (
        <p>
          <T text="t(Stock images are licensed for use as-is and can't be edited—adding logos, text, or filters may violate copyright laws.)" /> <Button { ...this._getLink() } />
        </p>
      )
    }
  }

  _getLink() {
    return {
      text: 't(See how to add branding)',
      className: 'link',
      link: 'https://help.truevail.com/article/307-editing-stock-images-in-your-email-campaigns'
    }
  }

  _getPanel() {
    return {
      title: 't(Licensing Warning)',
      leftItems: [
        { label: 't(Cancel)', handler: this._handleCancel }
      ],
      rightItems: [
        { label: 't(Done)', handler: this._handleCancel }
      ]
    }
  }
  
  _handleCancel() {
    this.context.modal.close()
  }

}

export default Copyright

